import axios from "axios";


export const getCountries = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/countries`
    return axios.get(url).then((res)=>{
        return res.data
    })
}

export const getClasses = async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/classes`
    return axios.get(url).then((res)=>{
        return res.data
    })
}

export const getCities = async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/cities`
    return axios.post(url,{cid:cid}).then((res)=>{
        return res.data
    })
}

export const getCountryCode = async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/country-code`
    return axios.post(url,{cid:cid}).then((res)=>{
        return res.data
    })
}
export const getSchools= async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/school`
    return axios.post(url,{cid:cid}).then((res)=>{
        return res.data
    })
}

export const getStudyCenter= async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/studycenter`
    return axios.post(url,{cid:cid}).then((res)=>{
        return res.data
    })
}

export const getCourses= async(cid,cls,stdCenter) => {
    const url = `${process.env.REACT_APP_API_URL}/api/courses`
    return axios.post(url,{cid:cid,class:cls,center:stdCenter}).then((res)=>{
        return res.data
    })
}

export const RegisterUser = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/register`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}


